import { render, staticRenderFns } from "./PoDetails.vue?vue&type=template&id=777dcf1a&scoped=true&"
import script from "./PoDetails.vue?vue&type=script&lang=js&"
export * from "./PoDetails.vue?vue&type=script&lang=js&"
import style0 from "./PoDetails.vue?vue&type=style&index=0&id=777dcf1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777dcf1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777dcf1a')) {
      api.createRecord('777dcf1a', component.options)
    } else {
      api.reload('777dcf1a', component.options)
    }
    module.hot.accept("./PoDetails.vue?vue&type=template&id=777dcf1a&scoped=true&", function () {
      api.rerender('777dcf1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget/PoDetails.vue"
export default component.exports